module.exports = __webpack_public_path__ + "static/media/TxVertical.5bf5ea01.png";